import { useMediaQuery, Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import EventsPageDesktop from './EventsPageDesktop';
import EventsPageMobile from './EventsPageMobile';

import { useEvents } from 'hooks';

const EventsPage = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const { events, fetchEvents } = useEvents();

  useEffect(() => {
    if (!events || events?.length === 0) {
      fetchEvents();
    }
  }, []);

  return (
    <Grid container>
      <Grid item container>
        {isMobile && <EventsPageMobile />}
        {!isMobile && <EventsPageDesktop />}
      </Grid>
    </Grid>
  );
};

export default EventsPage;
